export default __webpack_public_path__ + "static/media/kuesioner-bg.893a212a.png";